<div class="h2 content-title text-center p-3">
  Dolgozók és Képviselő testület
</div>

<div class="content my-3 col-lg-10 mx-auto">
  <div class="h4 content-title text-center py-3 col-lg-10 mx-auto">
    Tatai Közös Önkormányzati Hivatal Dunaszentmiklósi Kirendeltsége
  </div>
  <div class="px-5 col-lg-8 mx-auto my-4">
    <div class="row h5 mt-3 justify-content-center">
      <div class="col-lg-6 text-center">
        dr. Horváth József (székhelytelepülés Tata)
      </div>
      <div class="col-lg-6 text-center">jegyző</div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6 text-center">E-mail</div>
      <div class="col-lg-6 text-center">jegyzoititkarsag@tata.hu</div>
    </div>
    <div class="row bb pb-3 justify-content-center">
      <div class="col-lg-6 text-center">Telefon</div>
      <div class="col-lg-6 text-center">+36 (34) 588-616</div>
    </div>

    <div class="row h5 mt-3 justify-content-center">
      <div class="col-lg-6 text-center">Béger Ákos Imre</div>
      <div class="col-lg-6 text-center">polgármester</div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6 text-center">E-mail</div>
      <div class="col-lg-6 text-center">polgarmester@dunaszentmiklos.hu</div>
    </div>
    <div class="row bb pb-3 justify-content-center">
      <div class="col-lg-6 text-center">Telefon</div>
      <div class="col-lg-6 text-center">06-30/5201-812</div>
    </div>

    <div class="row h5 mt-3 justify-content-center">
      <div class="col-lg-6 text-center">Schrenkné Beleznai Tímea</div>
      <div class="col-lg-6 text-center">pénzügyi ügyintéző, adóügyi előadó</div>
    </div>
    <div class="row bb pb-3 justify-content-center">
      <div class="col-lg-6 text-center">E-mail</div>
      <div class="col-lg-6 text-center">gazdalkodas@dunaszentmiklos.hu</div>
    </div>

    <div class="row h5 mt-3 justify-content-center">
      <div class="col-lg-6 text-center">Gall Ildikó</div>
      <div class="col-lg-6 text-center">
        Igazgatási ügyintéző, Települési anyakönyvvezető, Hagyatéki, Szociális
        ügyek, Kereskedelmi Tevékenységek, Pályázatok
      </div>
    </div>
    <div class="row bb pb-3 justify-content-center">
      <div class="col-lg-6 text-center">E-mail</div>
      <div class="col-lg-6 text-center">igazgatas@dunaszentmiklos.hu</div>
    </div>

    <div class="row bb pb-3 h5 mt-3 justify-content-center">
      <div class="col-lg-6 text-center">Stegmayer Viktorné</div>
      <div class="col-lg-6 text-center">hivatalsegéd</div>
    </div>

    <div class="row h5 mt-3 justify-content-center">
      <div class="col-lg-6 text-center">Kristófné Horváth Bernadett</div>
      <div class="col-lg-6 text-center">közösségszervező</div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6 text-center">E-mail</div>
      <div class="col-lg-6 text-center">kozosseg@dunaszentmiklos.hu</div>
    </div>
    <div class="row bb pb-3 justify-content-center">
      <div class="col-lg-6 text-center">Telefon</div>
      <div class="col-lg-6 text-center">+36202996387</div>
    </div>
  </div>
  <div class="h4 content-title text-center py-3 col-lg-10 mx-auto">
    Képviselő-testület tagok
  </div>
  <div class="px-5 col-lg-8 mx-auto my-4">
    <div class="row">
      <div class="col-lg-6 text-center">Béger Ákos Imre</div>
      <div class="col-lg-6 text-center">polgármester</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Búzer Norbert</div>
      <div class="col-lg-6 text-center">alpolgármester</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Keil Richárd</div>
      <div class="col-lg-6 text-center">képviselő</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Hartmann Ádám</div>
      <div class="col-lg-6 text-center">képviselő</div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center">Pesti Viktória</div>
      <div class="col-lg-6 text-center">képviselő</div>
    </div>
  </div>
</div>
